import React, { useState, useEffect } from "react";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import { Grid } from "@material-ui/core";
import { Formik, Form } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import EditIcon from "@material-ui/icons/Edit";
import BiztranControls from "../../biztran_controls/BiztranControls";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';



const CreateSupplierMaster = (props) => {
    const [SrNo, setSrNo] = useState("");
    const [isOpen, setOpen] = useState(false);
    const [Remarks, setRemarks] = useState("");
    const [PocTestsMasterID, setPocTestsMasterID] = useState("");
    const [Features, setFeatures] = useState("");
    const [FeatureGroup, setFeatureGroup] = useState("");
    const [featuregrpcmb, setFeaturegrpcmb] = useState("");
    const [response, fetchData] = UseFetchData();
    const [SupplierName, SetSupplierName] = useState("");
    const [Address, setAddress] = useState("");
    const [VAT, SetVAT] = useState("");
    const [TIN, setTIN] = useState("");
    const [SerTaxNo, setSerTaxNo] = useState("");

    const featuregrpcmb01 = [
        { key: "Cloud Services Model", value: "Cloud Services Model" },
        { key: "Domain Environment", value: "Domain Environment" },
        { key: "General/Messaging Client", value: "General/Messaging Client" },
        { key: "General/Messaging Server/Administrative", value: "General/Messaging Server/Administrative" },
        { key: "Collaboration", value: "Collaboration" },
        { key: "Communication", value: "Communication" },
        { key: "Mobility & Desktop", value: "Mobility & Desktop" },
        { key: "Security", value: "Security" },
        { key: "Administration", value: "Administration" },
        { key: "Migration", value: "Migration" },

    ];



    useEffect(() => {

        ReasonSolutiondataopt();
    }, [])
    const ReasonSolutiondataopt = () => {

        let SolutionTypeCombo = featuregrpcmb01.map((data) =>
            <option

                value={data.key}
                key={data.value}
            >
                {data.key}
            </option>
        );
        setFeaturegrpcmb(SolutionTypeCombo);
    };
    const onSubmit = (values) => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("PocTestsMasterID", props.PocTestsMasterID);
        bodyFormData.append("SrNo", SrNo);
        bodyFormData.append("FeatureGroup", FeatureGroup);
        bodyFormData.append("Features", Features);
        bodyFormData.append("Remarks", Remarks);
        fetchData("Primary/PocTestinsert", bodyFormData);
    }

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert("Data Saved Succesfully.");
            // props.PopulateData();
            props.setpoctest(false);
        }
        else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
            }
        }
    }, [response]);

    return <div>
        <Formik initialValues={{}}
            // validationSchema={validationSchema}
            onSubmit={onSubmit} enableReinitialize>
            {formik => {
                return <Form>
                    <Grid spacing={1} container direction="row" >
                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"SupplierCode"}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"Supplier Code."}
                                </label>
                            </Grid>
                            <Grid item xs={4} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="SupplierCode"
                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>


                        </Grid>


                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2} >
                                <label
                                    htmlFor={"SupplierName"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Supplier Name"}
                                </label>
                            </Grid>
                            <Grid item xs={10} style={{ paddingLeft: 2 }} >
                                <BiztranControlsFormik
                                    // autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="SupplierName"
                                    // ref={ref}
                                    value={SupplierName}
                                    onChange={(e) => {
                                        SetSupplierName(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2} >
                                <label
                                    htmlFor={"Address"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Address"}
                                </label>
                            </Grid>
                            <Grid item xs={10} style={{ paddingLeft: 2 }} >
                                <BiztranControlsFormik
                                    // autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="Address"
                                    // ref={ref}
                                    value={Address}
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        // handleChange()
                                    }}
                                />
                                <BiztranControlsFormik
                                    // autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="Address"
                                    // ref={ref}
                                    value={Address}
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        // handleChange()
                                    }}
                                />
                                <BiztranControlsFormik
                                    // autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="Address"
                                    // ref={ref}
                                    value={Address}
                                    onChange={(e) => {
                                        setAddress(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"Phone1"}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"Phone1"}
                                </label>
                            </Grid>
                            <Grid item xs={4} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Phone1"
                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        // setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"Phone2"}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"Phone2"}
                                </label>
                            </Grid>
                            <Grid item xs={4} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Phone2"

                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        // setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>

                        </Grid>
                        <Grid item xs={12} container direction='row'>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"Mobile"}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"Mobile"}
                                </label>
                            </Grid>
                            <Grid item xs={4} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="Mobile"
                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        // setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <label
                                    htmlFor={"PANNo."}
                                    style={{

                                        width: "50",
                                    }}
                                >
                                    {"PAN No."}
                                </label>
                            </Grid>
                            <Grid item xs={4} width="10">
                                <BiztranControlsFormik
                                    control="input"
                                    type="text"
                                    name="PANNo."
                                    // ref={ref}
                                    value={SrNo}
                                    onChange={(e) => {
                                        // setSrNo(e.target.value)
                                        // handleChange()
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} container direction='row'>
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"VAT/TIN"}
                                        style={{

                                            width: "50",
                                        }}
                                    >
                                        {"VAT/TIN"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} width="10">
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="VAT/TIN"
                                        // ref={ref}
                                        value={VAT / TIN}
                                        onChange={(e) => {
                                            // setSrNo(e.target.value)
                                            // handleChange()
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <label
                                        htmlFor={"SerTaxNo"}
                                        style={{

                                            width: "50",
                                        }}
                                    >
                                        {"SerTax No"}
                                    </label>
                                </Grid>
                                <Grid item xs={4} width="10">
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="SerTaxNo"
                                        // ref={ref}
                                        value={SerTaxNo}
                                        onChange={(e) => {
                                            // setSrNo(e.target.value)
                                            // handleChange()
                                        }}
                                    />
                                </Grid>


                            </Grid>


                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                    <BiztranControls.Button
                                        text="Update"
                                        type="submit"
                                        startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="Delete"
                                        type="delete"
                                        startIcon={<SaveIcon />}
                                    />
                                    <BiztranControls.Button
                                        text="CLOSE"
                                        startIcon={<CloseIcon />}
                                        onClick={() => { props.setpoctest(false); }}
                                    />
                                </div>
                            </div>
                        </Grid>
                    </Grid>

                </Form>
            }}
        </Formik>
    </div>

}



export default CreateSupplierMaster;